import React from 'react'
import styled from 'styled-components'
import LongForm from './LongForm'
import bg0 from '../assets/images/M&S_selection3.jpg'
import bg1 from '../assets/images/Hummus.jpg'
import bg2 from '../assets/images/ICR-Jus.jpg'
import bg3 from '../assets/images/Ice.jpg'
import bg4 from '../assets/images/Louis-et-Adrien.jpg'
import bg5 from '../assets/images/Paroles-de-Fromagers.jpg'
import bg6 from '../assets/images/Monsieur-Saucisse.jpg'
import bg7 from '../assets/images/Vapeurs.jpg'

const MainBlock = styled.div`
  .carousel-item {
    height: 100vh;
    min-height: 300px;
    background: no-repeat center center scroll;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
  .carousel-indicators li {
    background: white;
  }
  .carousel-indicators li.active {
    background: #fc4c4c;
  }
  .carousel-control-next,
  .carousel-control-prev {
    width: 5%;
  }

  .picture,
  .text {
    height: 100%;
    width: 50%;
  }

  .text {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .text-content {
    max-width: 70%;
    font-size: 1.2em;
    .title {
      font-size: 2em;
      font-weight: 900;
      position: relative;
      margin-bottom: 30px;
      line-height: 1;
      &:after {
        content: '';
        display: block;
        position: absolute;
        bottom: -15px;
        height: 7px;
        width: 50px;
        background: #fc4c4c;
        border-radius: 20px;
      }
    }
    .subtitle {
    }
  }

  .picture {
    background-size: cover;
    background-position: center;
  }
  .content {
    display: flex;
    width: 100%;
    height: 100%;
  }
`

const _MainBlock = () => (
  <MainBlock>
    <header>
      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-interval="false"
      >
        <ol className="carousel-indicators">
          <li
            data-target="#carouselExampleIndicators"
            data-slide-to="0"
            className="active"
          />
          <li data-target="#carouselExampleIndicators" data-slide-to="1" />
          <li data-target="#carouselExampleIndicators" data-slide-to="2" />
          <li data-target="#carouselExampleIndicators" data-slide-to="3" />
          <li data-target="#carouselExampleIndicators" data-slide-to="4" />
          <li data-target="#carouselExampleIndicators" data-slide-to="5" />
          <li data-target="#carouselExampleIndicators" data-slide-to="6" />
          <li data-target="#carouselExampleIndicators" data-slide-to="7" />
        </ol>
        <div className="carousel-inner" role="listbox">
          <div className="carousel-item active">
            <div className="content">
              <div className="text">
                <div className="text-content">
                  <div className="title">Les animations Monbanquet.fr</div>
                  <div className="subtitle">
                    Vous organisez une soirée dans le cadre de votre entreprise
                    ou de votre association ? Vous vous dîtes que quelques
                    amuse-bouches pourraient être sympas mais qu'il vous
                    faudrait une touche en plus pour animer la soirée ? Vous
                    êtes au bon endroit ! Ici, nous vous dévoilons nos
                    animations, des plus franchouillardes aux plus exotiques.
                    Nos artisans dévoilent leur talents à travers des animations
                    qui apporteront dynamisme et convivialité à votre soirée !
                  </div>
                </div>
              </div>
              <div
                className="picture p1"
                style={{ backgroundImage: `url(${bg0})` }}
              />
            </div>
          </div>

          <div className="carousel-item ">
            <div className="content">
              <div className="text">
                <div className="text-content">
                  <div className="title">Houmous Bar</div>
                  <div className="subtitle">
                    Ils viennent dresser directement chez vous leur Houmous Bar
                    avec tous leur produits : Houmous, patates douces rôties,
                    taboulé libanais, caviar d’aubergines, Shakshuka …
                  </div>
                </div>
              </div>
              <div
                className="picture p1"
                style={{ backgroundImage: `url(${bg1})` }}
              />
            </div>
          </div>

          <div className="carousel-item">
            <div className="content">
              <div className="text">
                <div className="text-content">
                  <div className="title">Les Jus minutes Ice Roll</div>
                  <div className="subtitle">
                    Extraction du jus à froid sous vos yeux. Ils utilisent des
                    fruits frais et des épices subtiles pour des jus
                    d’exception, ce sont des cocktails de jus !
                  </div>
                </div>
              </div>
              <div
                className="picture p1"
                style={{ backgroundImage: `url(${bg2})` }}
              />
            </div>
          </div>
          <div className="carousel-item">
            <div className="content">
              <div className="text">
                <div className="text-content">
                  <div className="title">Les glaces minutes Ice Roll</div>
                  <div className="subtitle">
                    Découvert au nord de la Thailande, c’est une glace réalisé
                    sur une plaque négative à partir de fruits frais réduit en
                    purée. IceRoll nous propose des associations de goûts
                    (Abricot & Menthe; Coco & Mangue; Caramel & Noisettes;
                    Framboise; Zeste citron vert & Gingembre)
                  </div>
                </div>
              </div>
              <div
                className="picture p1"
                style={{ backgroundImage: `url(${bg3})` }}
              />
            </div>
          </div>
          <div className="carousel-item">
            <div className="content">
              <div className="text">
                <div className="text-content">
                  <div className="title">Louis & Adrien</div>
                  <div className="subtitle">
                    En 2013, après des études de commerce, ils sillonnent la
                    France entière à la recherche de produits d’exception et de
                    savoir-faire locaux. Ils montent à la capitale avec le
                    coffre plein à craquer de charcuteries et de fromages et
                    viennent vous proposer divers animations : Découpe de
                    charcuteries, dégustation de fromages, bar à tapenades,
                    croques et burgers minute…
                  </div>
                </div>
              </div>
              <div
                className="picture p1"
                style={{ backgroundImage: `url(${bg4})` }}
              />
            </div>
          </div>
          <div className="carousel-item">
            <div className="content">
              <div className="text">
                <div className="text-content">
                  <div className="title">Paroles de Fromagers</div>
                  <div className="subtitle">
                    L’initiation à l’art du fromage ! Nos artisans expliquent à
                    vos convives la provenance et l’histoire des fromages tout
                    en les dressant en sculptures. Cela peut être complété par
                    une initiation : "Comment associer le vin avec le fromage ?
                    »
                  </div>
                </div>
              </div>
              <div
                className="picture p1"
                style={{ backgroundImage: `url(${bg5})` }}
              />
            </div>
          </div>
          <div className="carousel-item">
            <div className="content">
              <div className="text">
                <div className="text-content">
                  <div className="title">Monsieur Saucisse</div>
                  <div className="subtitle">
                    Un produit inspiré de l’icône de la streetfood américaine,
                    réinventé à la française avec style et gourmandise Des
                    tricycles de charme pour la préparation des hot dogs,
                    passe-partout pour s’installer dans toutes les conditions
                    Préparation des hot dogs à la minute sous les yeux de vos
                    invités !
                  </div>
                </div>
              </div>
              <div
                className="picture p1"
                style={{ backgroundImage: `url(${bg6})` }}
              />
            </div>
          </div>
          <div className="carousel-item">
            <div className="content">
              <div className="text">
                <div className="text-content">
                  <div className="title">Vapeurs</div>
                  <div className="subtitle">
                    Le dim sum est une petite bouchée cuite à la vapeur dans un
                    panier en bambou. Toutes ses bouchées sont préparées par son
                    chef à base de produits frais et ses cuissons effectuées
                    devant vos convives sur leurs carrioles revisitées ou leurs
                    meubles de cuissons.
                  </div>
                </div>
              </div>
              <div
                className="picture p1"
                style={{ backgroundImage: `url(${bg7})` }}
              />
            </div>
          </div>
        </div>
        <a
          className="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true" />
          <span className="sr-only">Previous</span>
        </a>
        <a
          className="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true" />
          <span className="sr-only">Next</span>
        </a>
      </div>
    </header>
  </MainBlock>
)

export default _MainBlock



// WEBPACK FOOTER //
// ./src/components/MainBlock.js